import { AimOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { ManageInitiatives } from '@ui/initiatives';
import React, { useCallback } from 'react';
import { useAddToInitiative, useCurrentInitiative, useInitiativeWorkflow, useRemoveFromInitiative, useSonarObjectReference } from '@hooks';
export const PeriscopeInitiatives = ({ sonarObjectId }) => {
    const { request: add } = useAddToInitiative();
    const { request: remove } = useRemoveFromInitiative();
    const isInitiativeWorkflowActive = useInitiativeWorkflow();
    const currentInitiative = useCurrentInitiative();
    const initiativesForSonarObject = useSonarObjectReference(sonarObjectId).initiativeIds;
    const hasInitiative = Boolean(currentInitiative && initiativesForSonarObject.includes(currentInitiative.id));
    const handleClick = useCallback(() => {
        if (!currentInitiative) {
            return;
        }
        const { id, title } = currentInitiative;
        if (hasInitiative) {
            remove({
                initiativeId: id,
                sonarObjectIds: [sonarObjectId]
            });
        }
        else {
            add({
                initiativeId: id,
                initiativeTitle: title,
                sonarObjectIds: [sonarObjectId]
            });
        }
    }, [add, currentInitiative, hasInitiative, remove, sonarObjectId]);
    if (!isInitiativeWorkflowActive) {
        return React.createElement(ManageInitiatives, { sonarObjectId: sonarObjectId });
    }
    return (React.createElement("div", { className: 'manage-initiatives' },
        React.createElement(Button, { danger: hasInitiative, icon: React.createElement(AimOutlined, null), onClick: handleClick }, hasInitiative ? COPY_SPECIFIC.REMOVE_FROM_INITIATIVE : COPY_SPECIFIC.ADD_TO_INITIATIVE)));
};
